import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import * as pdfjs from 'pdfjs-dist';
import App from './App';
import './index.css';
import { msalConfig } from './auth-config';
import LocalStorageService from './application/features/common/local-storage-service';
import { store } from './application/store';
// import MainLoader from './ui/components/common/MainLoader';
import './application/utility/i18n';
import CustomThemeProvider from './theme';
import Loader from './ui/components/common/loader';
// Configure PDF.js worker for Azure deployment
//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
const container = document.getElementById('root') ?? document.createElement('root');
const root = createRoot(container);
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length) {
        msalInstance.setActiveAccount(accounts[0]);
    }
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
        else if (event.eventType === EventType.LOGOUT_SUCCESS)
            LocalStorageService.removeAccessToken();
    });
});
root.render(_jsx(Provider, { store: store, children: _jsxs(MsalProvider, { instance: msalInstance, children: [_jsx(Loader, {}), _jsx(CustomThemeProvider, { children: _jsx(App, {}) })] }) }));
